import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

type LinkProps = {
  to: string;
  label: string;
  className?: string;
};

function Navbar() {
  return (
    <header className="borber-b-2 box-content border-solid border-b-white bg-[#222222] text-white sm:h-[90px]">
      <nav
        className="layout-base flex h-full flex-col flex-wrap items-center justify-center sm:flex-row sm:justify-between"
        role="navigation"
      >
        <Link to="/" className="h-full w-auto">
          <StaticImage
            src="../../images/rlc-logo.png"
            alt="Response Logo"
            className="h-full w-auto"
            objectFit="contain"
            objectPosition="center"
          />
        </Link>
        <ul
          role="navigation"
          className="flex h-full items-center max-sm:flex-wrap max-sm:justify-center max-sm:pt-8 md:gap-x-4"
        >
          <NavLink to="/" label="Home" />
          <NavLink to="/get-in-touch" label="Get In Touch" />
          <NavLink to="/working-with-rlc" label="Working with RLC" />
        </ul>
      </nav>
    </header>
  );
}

const NavLink = ({ to, label }: LinkProps) => {
  return (
    <li className="grid place-items-stretch">
      <Link
        className="border-b-4 border-solid border-b-transparent px-2 py-2 font-nav text-xl hover:border-b-white sm:text-lg md:px-4 md:text-xl lg:text-2xl"
        activeClassName="border-b-white"
        to={to}
      >
        {label}
      </Link>
    </li>
  );
};

export default Navbar;
